import { useNavigate } from "react-router-dom";

import { useEffect, useRef, useState } from "react";
import { menuItems } from "./menu-items";
import { notifications } from "./data";
import { path } from "../../navigation/path";
import { hasPermissionSync } from "../../utils/get-user-permissions";
import ThemeToggle from "../theme-toggle/ThemeToggle";

// Helper function to get permission for a route path
const getPermissionForPath = (routePath: string): string | null => {
  // Map paths to permissions
  const pathPermissionMap: Record<string, string | null> = {
    [path.MESSAGING]: "messaging.compose",
    [path.MESSAGE_TRANSACTIONS]: "messaging.view",
    [path.MESSAGE_ANNIVERSARIES]: "messaging.view",
    [path.OCCASION_VERSES]: "messaging.view",
    [path.MEMBERS]: "member.view",
    [path.MY_PROFILE]: null,
    [path.ZONES]: "zone.view",
    [path.GROUPS]: "group.view",
    [path.TEAMS]: "team.view",
    [path.STREAM_VEHICLE]: "vehicle.stream",
    [path.VEHICLES]: "vehicle.view",
    [path.VISITORS]: "visitor.view",
    [path.CONFIG]: "config.manage",
    [path.USERS]: "user.manage",
    [path.REQUESTS]: "request.manage",
    [path.CAMERAS]: "camera.manage",
    [path.NODES]: "node.manage",
    [path.AUDIT]: "audit.view",
    [path.LOCATIONS]: "location.manage",
    [path.BIBLE_MANAGEMENT]: "bible.manage",
    [path.ROLES]: "role.manage",
  };
  
  return pathPermissionMap[routePath] || null;
};

export default function Header() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [showMessaging, setShowMessaging] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setActiveMenu(null);
        setShowProfileMenu(false);
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleProfileClick = () => {
    setShowProfileMenu(false);
    navigate("/profile");
  };

  const handleLogoutClick = () => {
    setShowProfileMenu(false);
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("member_id");
    localStorage.removeItem("zone_admin_zone_ids");
    localStorage.removeItem("permissions");
    localStorage.removeItem("roleEntity");
    localStorage.removeItem("isSuperAdmin");
    navigate("/login");
  };

  return (
    <header
      className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 sticky top-0 z-50 transition-colors duration-200"
      ref={menuRef}
    >
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <a
            href="/"
            className="visited:text-neutral-800 dark:visited:text-neutral-200 text-neutral-800 dark:text-neutral-200 hover:no-underline"
          >
            <div className="flex items-center space-x-4">
              <i className="fa-solid fa-cube text-2xl text-neutral-800 dark:text-neutral-200"></i>
              <span className="text-xl text-neutral-800 dark:text-neutral-200">
                Campus-Z
              </span>
            </div>
          </a>

          <div className="flex items-center space-x-6">
            <div>
              <button className="btn-danger px-5 py-2.5 text-sm"
                onClick={() => {
                  navigate(path.MESSAGING_EMERGENCY_ALERT)
                }}
              >
                Emergency Alert
              </button>
              {showMessaging == true ? <div>

              </div> : <></>}
            </div>
            <ThemeToggle />
            <div className="relative">
              <button
                onClick={() => setShowMenu(!showMenu)}
                className="flex items-center space-x-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded-lg transition-all duration-200"
              >
                <i className="fa-solid fa-bell text-lg"></i>
                <span className="bg-red-500 text-white px-2 py-0.5 rounded-full text-xs font-semibold">
                  3
                </span>
              </button>
              {showMenu && (
                <div className="dropdown-menu right-0 w-80">
                  <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                      Notifications
                    </h3>
                  </div>
                  <div className="max-h-96 overflow-y-auto">
                    {notifications.map((notification) => (
                      <div
                        key={notification.id}
                        className="p-4 border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-150 cursor-pointer"
                      >
                        <div className="flex items-start space-x-3">
                          <div
                            className={`p-2 rounded-lg ${notification.iconBg} ${notification.iconColor}`}
                          >
                            <i className={`${notification.icon} text-lg`}></i>
                          </div>
                          <div className="flex-1">
                            <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                              {notification.title}
                            </p>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                              {notification.message}
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
                              {notification.time}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-4 border-t border-gray-200 dark:border-gray-700">
                    <button className="w-full text-center text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium py-2 rounded-md hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors duration-150">
                      View All Notifications
                    </button>
                  </div>
                </div>
              )}
            </div>
            {/* <button className="flex items-center space-x-2">
              <i className="fa-solid fa-shopping-cart text-neutral-700"></i>
              <span className="bg-neutral-200 px-2 py-1 rounded-full text-sm">
                2
              </span>
            </button> */}
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setShowProfileMenu(!showProfileMenu)}
                className="flex items-center space-x-2 focus:outline-none"
              >
                <img
                  src="https://api.dicebear.com/7.x/notionists/svg?scale=200&seed=123"
                  className="w-8 h-8 rounded-full"
                  alt="Profile"
                />
                <i className="fa-solid fa-chevron-down text-sm text-neutral-600 dark:text-neutral-400"></i>
              </button>
              {showProfileMenu && (
                <div className="dropdown-menu right-6 top-16 w-48">
                  <button
                    onClick={handleProfileClick}
                    className="dropdown-item"
                  >
                    <i className="fa-solid fa-user"></i>
                    <span>Profile</span>
                  </button>
                  <button
                    onClick={handleLogoutClick}
                    className="dropdown-item dropdown-item-danger"
                  >
                    <i className="fa-solid fa-right-from-bracket"></i>
                    <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Navigation Menu */}
      <div className="px-6 py-3 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
        <nav className="flex items-center space-x-6">
          {Object.entries(menuItems)
            .filter(([key, item]) => {
              // Special handling for Admin menu - hide if user only has member-based roles
              if (key === "admin") {
                const permissionsStr = localStorage.getItem("permissions");
                if (permissionsStr) {
                  try {
                    const permissions: string[] = JSON.parse(permissionsStr);
                    const hasUserManage = permissions.includes("user.manage");
                    const hasMemberManage = permissions.includes("member.manage");
                    
                    // If user only has member.manage but not user.manage, check if they have any other admin permissions
                    if (hasMemberManage && !hasUserManage) {
                      // Check if user has access to any other admin submenu items
                      const hasOtherAdminAccess = item.submenu.some((subItem) => {
                        // Skip User Management
                        if (subItem.path === path.USERS) {
                          return false;
                        }
                        const requiredPermission = subItem.permission || getPermissionForPath(subItem.path);
                        if (requiredPermission) {
                          return hasPermissionSync(requiredPermission);
                        }
                        if (subItem.roles) {
                          const role = Number(localStorage.getItem("role"));
                          return subItem.roles.includes(role);
                        }
                        return true;
                      });
                      // If no other admin access, hide the entire Admin menu
                      if (!hasOtherAdminAccess) {
                        return false;
                      }
                    }
                  } catch (e) {
                    // If parsing fails, continue with normal check
                  }
                }
              }
              
              // Filter main menu items - show only if user has permission for at least one submenu item
              const hasAccessibleSubmenu = item.submenu.some((subItem) => {
                const requiredPermission = subItem.permission || getPermissionForPath(subItem.path);
                if (requiredPermission) {
                  return hasPermissionSync(requiredPermission);
                }
                // Legacy: check roles if no permission specified
                if (subItem.roles) {
                  const role = Number(localStorage.getItem("role"));
                  return subItem.roles.includes(role);
                }
                return true;
              });
              return hasAccessibleSubmenu;
            })
            .map(([key, item]) => (
            <div key={key} className="relative">
              <button
                onClick={() => setActiveMenu(activeMenu === key ? null : key)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  activeMenu === key
                    ? "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-100"
                }`}
              >
                <i className={item.icon}></i>
                <span>{item.label}</span>
                <i
                  className={`fa-solid fa-chevron-${activeMenu === key ? "up" : "down"
                    } text-xs transition-transform duration-200`}
                ></i>
              </button>
              {activeMenu === key && (
                <div className="dropdown-menu left-0 w-56">
                  {item.submenu
                    .filter((subItem) => {
                      // Special case: "User Management" should not be visible for member-based roles
                      if (subItem.path === path.USERS) {
                        const permissionsStr = localStorage.getItem("permissions");
                        if (permissionsStr) {
                          try {
                            const permissions: string[] = JSON.parse(permissionsStr);
                            // Check if user has user.manage specifically (not just member.manage)
                            const hasUserManage = permissions.includes("user.manage");
                            const hasMemberManage = permissions.includes("member.manage");
                            
                            // If user only has member.manage but not user.manage, hide it
                            if (hasMemberManage && !hasUserManage) {
                              return false;
                            }
                          } catch (e) {
                            // If parsing fails, continue with normal check
                          }
                        }
                      }
                      
                      // "My Information" shown only when user has member_id (e.g. no-role users)
                      if ((subItem as any).showWhenMemberId) {
                        return !!localStorage.getItem("member_id");
                      }
                      
                      // Get required permission for this menu item
                      const requiredPermission = subItem.permission || getPermissionForPath(subItem.path);
                      
                      // If no permission specified, check legacy roles
                      if (!requiredPermission && subItem.roles) {
                        const role = Number(localStorage.getItem("role"));
                        return subItem.roles.includes(role);
                      }
                      
                      // Check permission
                      if (requiredPermission) {
                        return hasPermissionSync(requiredPermission);
                      }
                      
                      // Default: show if no restrictions
                      return true;
                    })
                    .map((subItem, index) => (
                      <button
                        onClick={() => {
                          setActiveMenu(null);
                          navigate(subItem.path);
                        }}
                        key={index}
                        className="dropdown-item text-sm hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-700 dark:hover:text-blue-300"
                      >
                        <i className={subItem.icon}></i>
                        <span>{subItem.label}</span>
                      </button>
                    ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>
    </header>
  );
}
